import React, { useEffect } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Box, Divider } from '@chakra-ui/react';

import { JobProfilePage } from '../../../../../constants/duskIds';
import { createToast } from '../../../../../redux/modules/app';
import { createInsured } from '../../../../../redux/modules/insured';
import {
  addNewInsuredToCompanyList,
  setCurrentlyCreatingInsured,
  setJobsButtonPulse
} from '../../../../../redux/modules/jobs';
import { updateTrayProps } from '../../../../../redux/modules/tray';
import InsuredInfoSection
  from '../../../../InsuredsPage/components/CreateInsuredTray/CreateInsuredForm/InsuredInfoSection';
import InsuredRequiredInfoSection
  from '../../../../InsuredsPage/components/CreateInsuredTray/CreateInsuredForm/InsuredRequiredInfoSection';

const AddNewInsuredForm = () => {
  const dispatch = useDispatch();
  const useFormMethods = useForm();

  const { handleSubmit, control } = useFormMethods;
  const { isDirty } = useFormState({ control });

  useEffect(() => {
    dispatch(updateTrayProps({ formIsDirty: isDirty }));
  }, [isDirty]);

  const onSubmit = async data => {
    dispatch(setCurrentlyCreatingInsured(true));

    dispatch(createToast({
      title: 'Creating Insured...',
      duration: 2000,
      status: 'info'
    }));

    const newInsuredInfo = {
      insured_company_name: data.insuredCompanyName,
      insured_contact_name: data.insuredCompanyName,
      insured_email: data.insuredEmail,
      ...(data.insuredCc && { insured_cc: data.insuredCc }),
      external_id: data.externalId,
      insured_description: data.insuredDescription,
      insured_type: data.insured_type
    };

    const response = await dispatch(createInsured(newInsuredInfo));

    if (response) {
      dispatch(setJobsButtonPulse(true));
      dispatch(addNewInsuredToCompanyList(response));
      dispatch(setCurrentlyCreatingInsured(false));
    }
  };

  return (
    <Box mt={4}>
      <form dusk={JobProfilePage.addInsuredForm} id="createInsured" onSubmit={handleSubmit(onSubmit)}>
        <InsuredRequiredInfoSection useFormMethods={useFormMethods} />
        <Divider borderBottomWidth="3px" ml={-6} pl={12} />
        <InsuredInfoSection useFormMethods={useFormMethods} />
      </form>
    </Box>
  );
};

export default AddNewInsuredForm;
